import React, { useState } from 'react';
import './App.css'; 

function App() {
  const [word, setWord] = useState('');
  const [numRhymes, setNumRhymes] = useState(10);
  const [rhymes, setRhymes] = useState('');

  const fetchRhymes = async () => {
    try {
      const response = await fetch('https://rhyme-machine-backend-test.azurewebsites.net/get-rhymes', {  // http://127.0.0.1:5000/get-rhymes
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ word, num_rhymes: numRhymes }),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      setRhymes(data.rhymes);
    } catch (error) {
      console.error('Error fetching rhymes:', error);
      setRhymes('An error occurred while fetching rhymes. Please try again.');
    }
  };

  return (
    <div className="App">
      <div className="rhyme-container">
        <h1>Rhyme Machine</h1>
        <div className="subtitle">rap rhyme generator</div>
        <input
          type="text"
          placeholder="Enter a word"
          value={word}
          onChange={(e) => setWord(e.target.value)}
        />
        <input
          type="number"
          placeholder="Number of rhymes"
          value={numRhymes}
          onChange={(e) => setNumRhymes(e.target.value)}
        />
        <button onClick={fetchRhymes}>Get Rhymes</button>
        <pre>{rhymes}</pre>
      </div>
    </div>
  );
}

export default App;